import src from "IMAGE";
export default { src, width: 176, height: 568, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAASklEQVR42g3ISQ6AIBAEwH6mIq/zYlRQlnbCkjg8Ta+F2Ux2T+tA60XJUOETlfkW+OjK26P+chTHTSHx1MwgaE30EVaYxVifr/EB6oQqSny3kd0AAAAASUVORK5CYII="};
